import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Box,
  Typography,
  Link,
  Card,
  Fab,
  TextField,
  MenuItem,
  InputAdornment,
  Checkbox,
  IconButton,
  DialogContent,
  Dialog,
  DialogActions,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import moment from "moment-timezone";
import { useTheme } from "@emotion/react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useFormik } from "formik";
import * as Yup from "yup";

import { AuthContext } from "../../../../context/AuthContext";
import SelectQuickbooksCustomer from "../../Invoices/SelectQuickbooksCustomer";
import { LoadingButton } from "@mui/lab";
import { Close, Delete } from "@mui/icons-material";

const CreateInvoiceDialog = ({
  initialData,
  loading,
  errorMessage,
  onSubmit,
  open,
  onClose,
}) => {
  const navigate = useNavigate();
  const { authToken, ezorder } = useContext(AuthContext);
  const theme = useTheme();
  const [serviceOptions, setServiceOptions] = useState([]);

  const formValidationSchema = Yup.object({
    CustomerRef: Yup.object().nullable().required("Please select a customer"),
    Line: Yup.array().of(
      Yup.object().shape({
        DetailType: Yup.string().required(`Detail Type Required`), // DetailType: "SalesItemLineDetail",
        Amount: Yup.number().required("Invalid amount"),
        Description: Yup.string().required(`Item Description Required`),
        SalesItemLineDetail: Yup.object().shape({
          Qty: Yup.number()
            .positive("Item quantity must be greater than zero")
            .required("Item quantity required"),
          ServiceDate: Yup.string().required(`Service Date Required`),
          //   ItemRef: {
          //     name: Yup.string().required(`Item Ref Required`), // name: item.service.Name,
          //     value: Yup.string().required(`Item Ref Required`), // value: item.service.Id,
          //   },
          UnitPrice: Yup.number(),
          ItemRef: Yup.object().nullable().required("Item Ref Required"),
          TaxCodeRef: Yup.object().nullable().required("TaxCodeRef Required"),
          //   TaxCodeRef: {
          //     value: Yup.string().required(`Tax Code Ref Required`), //  item.isTaxed ? "TAX" : "NON",
          //   },
        }),
      })
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CustomerRef: initialData ? initialData.CustomerRef : null,
      Line: initialData ? initialData.Line : null,
    },
    validationSchema: formValidationSchema,
    validateOnBlur: false,
    validateOnChange: true,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  const getProductsAndServices = async () => {
    try {
      const response = await ezorder.get(
        `/quickbooks/invoice/products-services`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const items = response.data.items;
      // console.log("QB ITEMS: ");
      // console.log(items);
      setServiceOptions(items);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProductsAndServices();
  }, []);

  useEffect(() => {
    console.log(formik.values);
  }, [formik.values]);

  return (
    <Dialog
      fullScreen={true}
      fullWidth={true}
      open={open}
      onClose={() => {
        if (!loading) onClose(); // do not allow close when loading
      }}
    >
      <DialogContent>
        <Typography variant="h5" sx={{ textAlign: "center" }}>
          Create Invoice
        </Typography>
        <Box sx={{ marginTop: "16px" }}>
          <Typography variant="h6">Select Quickbooks Customer</Typography>
          <SelectQuickbooksCustomer
            qbCustomerId={
              formik.values.CustomerRef ? formik.values.CustomerRef.Id : null
            }
            onSelect={(qbCustomer) => {
              formik.setFieldValue("CustomerRef", { value: `${qbCustomer}` });
            }}
          />
          {formik.values.CustomerRef && (
            <Box sx={{ marginTop: "16px" }}>
              <Typography variant="h6">Invoice Items</Typography>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>#</TableCell>
                      <TableCell sx={{ minWidth: "200px" }}>
                        SERVICE DATE
                      </TableCell>
                      <TableCell sx={{ minWidth: "120px" }}>
                        PRODUCT/SERVICE
                      </TableCell>
                      <TableCell sx={{ minWidth: "300px" }}>
                        DESCRIPTION
                      </TableCell>
                      <TableCell sx={{ minWidth: "100px" }}>QTY</TableCell>
                      <TableCell sx={{ minWidth: "150px" }}>RATE</TableCell>
                      <TableCell sx={{ minWidth: "150px" }}>AMOUNT</TableCell>
                      <TableCell>TAX</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formik.values.Line &&
                      formik.values.Line.map((lineItem, index) => (
                        <TableRow
                          key={"input"}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell>
                            <IconButton
                              onClick={() => {
                                let LineCopy = [...formik.values.Line];
                                LineCopy.splice(index, 1);
                                formik.setFieldValue("Line", LineCopy);
                              }}
                            >
                              <Close />
                            </IconButton>
                          </TableCell>
                          <TableCell>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                              <DatePicker
                                label="Service Date"
                                value={moment(
                                  lineItem.SalesItemLineDetail.ServiceDate
                                ).format("MM/DD/YYYY")}
                                onChange={(newValue) => {
                                  let dateString =
                                    moment(newValue).format("MM/DD/YYYY");
                                  let LineCopy = [...formik.values.Line];
                                  LineCopy[
                                    index
                                  ].SalesItemLineDetail.ServiceDate =
                                    dateString;
                                  formik.setFieldValue("Line", LineCopy);
                                }}
                                renderInput={(params) => (
                                  <TextField fullWidth sx={{}} {...params} />
                                )}
                              />
                            </LocalizationProvider>
                          </TableCell>
                          <TableCell>
                            <TextField
                              select
                              size="small"
                              value={JSON.stringify(
                                lineItem.SalesItemLineDetail.ItemRef
                              )}
                              onChange={(e) => {
                                let LineCopy = [...formik.values.Line];
                                LineCopy[index].SalesItemLineDetail.ItemRef =
                                  JSON.parse(e.target.value);
                                formik.setFieldValue("Line", LineCopy);
                              }}
                              fullWidth
                            >
                              {serviceOptions.map((service, index) => (
                                <MenuItem
                                  key={index}
                                  value={JSON.stringify({
                                    name: service.Name,
                                    value: service.Id,
                                  })}
                                >
                                  {service.Name}
                                </MenuItem>
                              ))}
                            </TextField>
                          </TableCell>
                          <TableCell>
                            <TextField
                              fullWidth
                              size="small"
                              value={lineItem.Description}
                              //   onChange={handleChange("description")}
                              onChange={(e) => {
                                let LineCopy = [...formik.values.Line];
                                LineCopy[index].Description = e.target.value;
                                formik.setFieldValue("Line", LineCopy);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              onWheel={(event) => {
                                event.preventDefault();
                              }}
                              size="small"
                              value={lineItem.SalesItemLineDetail.Qty}
                              onChange={(e) => {
                                let LineCopy = [...formik.values.Line];
                                LineCopy[index].SalesItemLineDetail.Qty =
                                  e.target.value;
                                formik.setFieldValue("Line", LineCopy);
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              onWheel={(event) => {
                                event.preventDefault();
                              }}
                              size="small"
                              value={lineItem.SalesItemLineDetail.UnitPrice}
                              onChange={(e) => {
                                let LineCopy = [...formik.values.Line];
                                LineCopy[index].SalesItemLineDetail.UnitPrice =
                                  e.target.value;
                                formik.setFieldValue("Line", LineCopy);
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography
                                      style={{
                                        color: theme.palette.grey["500"],
                                      }}
                                    >
                                      $
                                    </Typography>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <TextField
                              type="number"
                              size="small"
                              onWheel={(event) => {
                                event.preventDefault();
                              }}
                              value={lineItem.Amount}
                              onChange={(e) => {
                                let LineCopy = [...formik.values.Line];
                                LineCopy[index].Amount = e.target.value;
                                formik.setFieldValue("Line", LineCopy);
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <Typography
                                      style={{
                                        color: theme.palette.grey["500"],
                                      }}
                                    >
                                      $
                                    </Typography>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Checkbox
                              checked={
                                lineItem.SalesItemLineDetail.TaxCodeRef.value ==
                                "TAX"
                              }
                              //   onChange={handleChange("isTaxed")}
                              onChange={(e) => {
                                let LineCopy = [...formik.values.Line];
                                LineCopy[
                                  index
                                ].SalesItemLineDetail.TaxCodeRef.value = e
                                  .target.checked
                                  ? "TAX"
                                  : "NON";
                                formik.setFieldValue("Line", LineCopy);
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      ))}

                    <TableCell colSpan={20} align="center">
                      <Button
                        onClick={() => {
                          let LineCopy = [...formik.values.Line];
                          LineCopy.push({
                            DetailType: "SalesItemLineDetail",
                            Amount: 0,
                            Description: "",
                            SalesItemLineDetail: {
                              Qty: 1,
                              UnitPrice: 0,
                              ServiceDate: moment().format(),
                              ItemRef: null,
                              TaxCodeRef: {
                                value: "TAX", //item.isTaxed ? "TAX" : "NON",
                              },
                            },
                          });
                          formik.setFieldValue("Line", LineCopy);
                        }}
                      >
                        Add More
                      </Button>
                    </TableCell>
                  </TableBody>
                </Table>
              </TableContainer>
              {!formik.values.CustomerRef && (
                <Typography
                  textAlign={"center"}
                  variant="caption"
                  sx={{ color: "#c0c1c2" }}
                >
                  Must Select QB Customer First
                </Typography>
              )}
            </Box>
          )}
          <Box>
            {errorMessage && (
              <Box>
                <Typography color={"red"}>{errorMessage}</Typography>
              </Box>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          sx={{ marginRight: "8px" }}
          // variant="outlined"
          loading={loading}
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </LoadingButton>
        {/* <LoadingButton
          color="success"
          // variant="contained"
          loading={loading}
          onClick={() => {
            handlePayment();
          }}
        >
          Save Payment
        </LoadingButton> */}
        <LoadingButton
          color="success"
          loading={loading}
          disabled={
            !formik.values.Line ||
            formik.values.Line.length <= 0 ||
            !formik.values.CustomerRef
          }
          // variant="outlined"
          // sx={{ marginLeft: "auto" }}
          onClick={() => {
            formik.handleSubmit();
          }}
        >
          Create Invoice
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default CreateInvoiceDialog;
